/**
 * Storefront mode for bpderma.com.
 *
 * SHOWCASE MODE (STORE_ENABLED = false): the site is a product catalogue only —
 * no shop page, no prices, no cart, no checkout. Buyers are routed to Nubia.
 * Flip STORE_ENABLED back to `true` (and rebuild) to restore full commerce.
 *
 * Typed as `boolean` (not the `false` literal) so the gating conditions in the
 * components don't trip "always false" lint rules.
 */
export const STORE_ENABLED: boolean = false;

/** Where buyers are sent while the shop is disabled. */
export const NUBIA_URL = "https://www.nubia.com.tr";

/** Localized "soon available on Nubia" CTA labels. Call sites fall back to `en`. */
export const SOON_LABELS: Record<string, string> = {
  en: "Soon available on Nubia",
  tr: "Yakında Nubia'da",
  de: "Bald erhältlich bei Nubia",
  ar: "قريبًا على Nubia",
  fr: "Bientôt disponible sur Nubia",
  es: "Pronto disponible en Nubia",
};

/** Localized secondary line ("soon at nubia.com.tr"). Call sites fall back to `en`. */
export const SOON_SUBLABELS: Record<string, string> = {
  en: "Soon at nubia.com.tr",
  tr: "Yakında nubia.com.tr'de",
  de: "Bald auf nubia.com.tr",
  ar: "قريبًا على nubia.com.tr",
  fr: "Bientôt sur nubia.com.tr",
  es: "Pronto en nubia.com.tr",
};
